import EnrolmentsSerializer from './base';

export default class Credential extends EnrolmentsSerializer {}
